<div [hidden]="chaseDetails == null" class="iframe_react_container">
  <app-iframe [visible]="isVisible" [load]="true" iframeSrc="{{iframeSrc}}"classes="{{classes}}"></app-iframe>
</div>